export const MUI_BUTTON_POSITIVE = "Mui-button-positive";
export const MUI_BUTTON_NEGATIVE = "Mui-button-negative";
export const MUI_BUTTON_NEXT = "Mui-button-next ";
export const MUI_BUTTON_BACK = "Mui-button-back ";

